import React from 'react';
import { UploadCloudIcon, RefreshCwIcon, CheckCircleIcon } from 'lucide-react';
export const HowItWorks = () => {
  return <section id="how-it-works" className="w-full py-16 md:py-24 px-6 md:px-12 bg-white dark:bg-gray-900" data-id="element-93">
      <div className="max-w-6xl mx-auto" data-id="element-94">
        <div className="text-center mb-16" data-id="element-95">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-96">
            How RootHealth Works
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-97">
            Our streamlined process takes the complexity out of CMS price
            transparency compliance
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-98">
          {/* Step 1 */}
          <div className="bg-green-50 dark:bg-gray-800 p-8 rounded-lg transition-all hover:shadow-md" data-id="element-99">
            <div className="bg-green-100 dark:bg-green-900/30 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-100">
              <UploadCloudIcon size={32} className="text-green-600 dark:text-green-400" data-id="element-101" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-102">1. Upload</h3>
            <p className="text-gray-600 dark:text-gray-300" data-id="element-103">
              Securely upload CSV, Excel, or JSON.
            </p>
          </div>
          {/* Step 2 */}
          <div className="bg-green-50 dark:bg-gray-800 p-8 rounded-lg transition-all hover:shadow-md" data-id="element-104">
            <div className="bg-green-100 dark:bg-green-900/30 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-105">
              <RefreshCwIcon size={32} className="text-green-600 dark:text-green-400" data-id="element-106" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-107">2. Normalize</h3>
            <p className="text-gray-600 dark:text-gray-300" data-id="element-108">
              We map your data to the CMS schema and flag gaps.
            </p>
          </div>
          {/* Step 3 */}
          <div className="bg-green-50 dark:bg-gray-800 p-8 rounded-lg transition-all hover:shadow-md" data-id="element-109">
            <div className="bg-green-100 dark:bg-green-900/30 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-110">
              <CheckCircleIcon size={32} className="text-green-600 dark:text-green-400" data-id="element-111" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-112">3. Comply</h3>
            <p className="text-gray-600 dark:text-gray-300" data-id="element-113">
              Receive CMS-ready files plus a hosted page with your RootHealth
              'Compliant' badge and a downloadable copy.
            </p>
          </div>
        </div>
      </div>
    </section>;
};